import { render } from "./billViewer2.vue?vue&type=template&id=57623eb8&scoped=true"
import script from "./billViewer2.vue?vue&type=script&lang=js"
export * from "./billViewer2.vue?vue&type=script&lang=js"

import "./billViewer2.vue?vue&type=style&index=0&id=57623eb8&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57623eb8"]])

export default __exports__